import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/Index'
import SignUp from '@/pages/SignUp'
import Login from '@/pages/Login'
import MealPlan from '@/pages/MealPlan'
import Plan from '@/pages/Plan'
import MyPlan from '@/pages/MyPlan'
import UserManage from '@/admin/UserManage';
import UserPlan from '@/admin/UserPlan';
import HolidayManage from '@/admin/HolidayManage';
import LinkChild from "@/pages/LinkChild";
import moment from 'moment';

const isNewMyPlan = (moment().week() === 10 || moment().week() === 11) && moment().year() === 2021;

export const routes = [
    { path: '/', component: Index, name: 'Start', navItem: false },
    { path: '/user-manage', component: UserManage, name: 'Benutzerverwaltung', navItem: true, admin: true },
    { path: '/holiday-manage', component: HolidayManage, name: 'Ferienverwaltung', navItem: true, admin: true },
    { path: '/manage-plan', component: UserPlan, name: 'Planverwaltung', navItem: true, admin: true },
    { path: '/my-plan', component: MyPlan, name: 'Meine Termine', navItem: true, new: isNewMyPlan },
    { path: '/plan', component: Plan, name: 'Alle Termine', navItem: true },
    { path: '/mealplan', component: MealPlan, name: 'Essensplan', navItem: true },
    { path: '/sign-up', component: SignUp, name: 'sign-up', navItem: false },
    { path: '/link-child', component: LinkChild, name: 'Kind hinzufügen', navItem: false, optionItem: true },
    { path: '/login', component: Login, name: 'login', navItem: false },
];

export const router = new VueRouter({
    routes
});

Vue.use(VueRouter);
